import jQuery from 'jquery/dist/jquery';
import Swal from 'sweetalert2';
import Utils from "../../../../utils";
import * as bootstrap from 'bootstrap'
import DefaultController from "../../../defaultController";
import StatusEntity from "../../../status/entity";

export default class SettingsTasksStatus extends DefaultController {
    private element: any;
    private datatable: any;
    private editModal: any;
    private currentId: any;
    entity = 'statuses'

    async init() {
        this.element = jQuery(".datatables-status")
        this.editModal = new bootstrap.Modal((document.querySelector("#editSettingsTicketStatusModal") as HTMLElement));
        this.loadTable();
        await super.init();
    }

    getEntityData(elem: any) {
        return StatusEntity.getEntityData(elem)
    }

    bindListeners() {
        (document.querySelector("#addNewStatusForm") as HTMLFormElement).addEventListener("submit", async (e) => {
            e.preventDefault();
            const elem = document.querySelector("#addNewStatusForm") as HTMLFormElement;
            const valid = elem.checkValidity();
            if (valid) {
                const r = await Utils.entity.upsert(this.getEntityData(elem), this.entity)
                if (r.status === 200) {
                    await this.datatable.ajax.reload();
                    elem.reset()
                    const bsElem = bootstrap.Offcanvas.getInstance((document.querySelector("#offcanvasAddStatus") as HTMLElement))
                    if (bsElem) {
                        bsElem.hide();
                    }
                    elem.reset();
                    this.toastr.success(`${Utils.translate('status.name')} ${Utils.translate('generic.messages.created')}`, `${Utils.translate('generic.success')}`)
                }
            }
        });
        this.element.delegate(".delete-record", "click", async (e: any) => {
            e.preventDefault();const confirm = await Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                customClass: {
                    confirmButton: 'btn btn-primary me-3',
                    cancelButton: 'btn btn-label-secondary'
                },
                buttonsStyling: false
            })
            if(confirm.value === true) {
                const id = e.currentTarget.getAttribute("data-id")
                const r = await Utils.entity.destroy(id, this.entity)
                if (r.status === 200) {
                    this.toastr.success(`${Utils.translate('status.name')} ${Utils.translate('generic.deleted')}`, `${Utils.translate('generic.success')}`)
                } else {
                    this.toastr.error(`${Utils.translate('status.name')} ${Utils.translate('generic.messages.not_deleted')}`, `${Utils.translate('generic.error')}`)
                }
                this.datatable.ajax.reload();
            }
        });
        this.element.delegate(".edit-record", "click", async (e: any) => {
            const id = e.currentTarget.getAttribute("data-id")
            this.currentId = id;
            const requestData = await Utils.entity.get(id, this.entity)
            if (requestData.status === 200) {
                const data = requestData.data[0]
                const form = (document.querySelector("#editSettingsTicketStatusForm") as HTMLFormElement);
                await Utils.updateElements(data, '', form)

                jQuery("#editSettingsTicketStatusForm #status_transitions").val("").trigger("change");
                data.transitions.forEach((transition: any) => {
                    const $newOption = jQuery("<option selected='selected'></option>").val(transition.uuid).text(transition.name)
                    jQuery("#editSettingsTicketStatusForm #status_transitions").append($newOption).trigger('change');
                })



                jQuery("#editSettingsTicketStatusForm #status_users").val("").trigger("change");
                data.users.forEach((user: any) => {
                    const $newOption = jQuery("<option selected='selected'></option>").val(user.uuid).text(user.name)
                    jQuery("#editSettingsTicketStatusForm #status_users").append($newOption).trigger('change');
                })

                this.editModal.show();
            }
        });
        (document.querySelector("#editSettingsTicketStatusForm") as HTMLFormElement).addEventListener("submit", async (e) => {
            e.preventDefault();
            const elem = document.querySelector("#editSettingsTicketStatusForm") as HTMLFormElement;
            const valid = elem.checkValidity();
            if (valid) {
                const r = await Utils.entity.upsert(this.getEntityData(elem), this.entity)
                if (r.status === 200) {
                    await this.datatable.ajax.reload();
                    elem.reset()
                    this.editModal.hide();
                    this.toastr.success(`${Utils.translate('status.name')} ${Utils.translate('generic.saved')}`, `${Utils.translate('generic.success')}`)
                }
            }
        })
    }



    onSelectFilterResults(data: any, entity: any, element: any) {
        console.log("R", data, entity)
        if (entity === "statuses") {
            return data.filter((d: { uuid: any; }) => d.uuid !== this.currentId)
        }
        return data;
    }

    loadTable() {
        this.datatable = new DataTable(this.element, {
            initComplete: () => {
                this.element.closest(".card").find(".loading-body").addClass("d-none")
                this.element.closest(".card").find(".card-datatable").removeClass("d-none")
            },
            ajax: `/api/v1/statuses`,
            columns: [
                {data: 'name'},
                {data: 'uuid'},
                {data: 'is_archive'},
                {data: 'uuid'}
            ],
            columnDefs: [
                {
                    targets: 0,
                    render: (data: any, type: any, full: any, meta: any) => {
                        return data;
                    },
                },
                {
                    targets: 1,
                    render: (data: any, type: any, full: any, meta: any) => {
                        return full.transitions.map((t: { name: any; }) => t.name).join(", ");
                    },
                },
                {
                    targets: 2,
                    render: (data: any, type: any, full: any, meta: any) => {
                        if(data) {
                            return '<span class="badge bg-label-primary p-2 rounded"><i class="ti ti-checkbox ti-sm"></i></span>';
                        } else {
                            return '<span class="badge bg-label-primary p-2 rounded"><i class="ti ti-square-off ti-sm"></i></span>'
                        }
                    },
                },
                {
                    targets: 3,
                    searchable: false,
                    orderable: false,
                    render: (data: any, type: any, full: any, meta: any) => {
                        return `<div class="d-flex align-items-center justify-content-end">
                                  <a data-id="${data}" class="text-body edit-record">
                                    <i class="ti ti-edit ti-sm me-2"></i>
                                  </a>
                                  <a href="#" data-id="${data}" class="text-body delete-record">
                                    <i class="ti ti-trash ti-sm mx-2"></i>
                                  </a>
                                </div>`
                    },
                }
            ],
            processing: true,
            dom:
                '<"row me-2 align-items-center"' +
                '<"col-md-2"<"me-3 m-3"l>>' +
                '<"col-md-10"<"dt-action-buttons text-xl-end text-lg-start text-md-end text-start d-flex align-items-center justify-content-end flex-md-row flex-column mb-3 mb-md-0"fB>>' +
                '>t' +
                '<"row mx-2 align-items-center justify-content-between"' +
                '<"col-6"i>' +
                '<"col-6 mt-3"p>' +
                '>',

            language: {
                sLengthMenu: '_MENU_',
                search: '',
                searchPlaceholder: `${Utils.translate('generic.search')}...`,
                "zeroRecords": `${Utils.translate('generic.datatable.no_results')}`,
                "emptyTable": `${Utils.translate('generic.datatable.no_results')}`,
                "paginate": {
                    "first": `${Utils.translate('generic.datatable.pagination.first')}`,
                    "last": `${Utils.translate('generic.datatable.pagination.last')}`,
                    "next": `${Utils.translate('generic.datatable.pagination.next')}`,
                    "previous": `${Utils.translate('generic.datatable.pagination.previous')}`
                },
                "info": `${Utils.translate('generic.datatable.info.info')}`,
                "infoEmpty": `${Utils.translate('generic.datatable.info.empty')}`,
                "infoFiltered": `${Utils.translate('generic.datatable.info.filtered')}`,
            },
            buttons: [
                {
                    text: `<i class="ti ti-plus me-0 me-sm-1 ti-xs"></i><span class="d-none d-sm-inline-block">${Utils.translate('generic.add')}</span>`,
                    className: 'dt-button add-new btn btn-primary m-2',
                    attr: {
                        'data-bs-toggle': 'offcanvas',
                        'data-bs-target': '#offcanvasAddStatus'
                    }
                }
            ]
        });
    }
}